const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  landingbaseurl: process.env.REACT_APP_LANDING_BASE_URL,
  invitationPageBaseUrl: process.env.REACT_APP_INVITAITON_PAGE_BASE_URL,
  imagesbaseurl: process.env.REACT_APP_IMAGE_BASE_URL,
  demoCategoryId : process.env.REACT_APP_DEMO_CATEGORY_ID,
  websiteCategoryId : process.env.REACT_APP_WEBSITE_CATEGORY_ID,
};

export default config;